<template>
  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">WoCoin History</h5>
          <span aria-hidden="true" role="button" @click="close"><i class="fas fa-xmark"></i></span>
        </div>
        <div class="modal-body">
          <Spinner v-if="this.isLoading">Fetching WoCoin History</Spinner>
          <div class="container mb-3" v-show="!this.isLoading">
            <div class="row mb-3">
              <button class="btn btn-primary" @click="showAdd = true" v-if="data.isAdd">
                Add Transaction
              </button>
              <button class="btn btn-primary" @click="showReward = true" v-else>
                Add Reward
              </button>
            </div>

            <data-table2 :api="getTransactions" :actions="actions" :headers="headers" :fields="['_id']"
              :trigger="trigger" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog" v-if="showAdd">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Transaction</h5>
          <span aria-hidden="true" role="button" @click="closeAdd"><i class="fas fa-xmark"></i></span>
        </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="mb-3">Transaction ID</label>
            <input type="text" class="form-control" v-model="orderid" />
          </div>
          <div class="form-group mb-3">
            <label class="mb-3">Amount</label>
            <select class="form-control" v-model="coinValue">
              <option v-for="product in products" v-bind:key="product" :value="product.coinValue">
                {{ product.coinValue }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeAdd">Close</button>
          <button type="button" class="btn btn-primary" @click="searchTransaction">
            Search Transaction
          </button>
          <button type="button" class="btn btn-success" @click="addAppleTransaction">
            Add Apple Transaction
          </button>
          <button type="button" class="btn btn-success" @click="addTransaction">
            Add Transaction
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog" v-if="showReward">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Reward</h5>
          <span aria-hidden="true" role="button" @click="closeAdd"><i class="fas fa-xmark"></i></span>
        </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="mb-3">Amount</label>
            <select class="form-control" v-model="coinValue">
              <option v-for="product in products" v-bind:key="product" :value="product.coinValue">
                {{ product.coinValue }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeAdd">Close</button>
          <button type="button" class="btn btn-success" @click="addReward">
            Add Reward
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" v-if="showReceipt && receiptData != null">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">View Receipt</h5>
          <span aria-hidden="true" role="button" @click="showReceipt = false"><i class="fas fa-xmark"></i></span>
        </div>
        <div class="modal-body">
          <div class="google-container">
            <div class="google-receipt">
              <div class="gplay-logo" v-if="receiptData.payload.Store == 'GooglePlay'">
                <img
                  src="https://ci3.googleusercontent.com/meips/ADKq_NbX5DC9KzbBsmPgX88IowvG_X8atMjCsyS0Ieb2UVYUO3H25ZOjXFQkpM7XIWU1qKgVKmWz0VvfimMhObWWTHkPRzDiiRX_kfNF7pNUdXPWtr5-fHt8Kd7N_ZrV36YKL7EZNQUoaXuf5EQzxBVUOtqlpU8nTi59FA=s0-d-e1-ft#https://www.gstatic.com/gumdrop/files/google-play-crm-lockup-ic-h-transparent-w688px-h140px-2x.png" />
              </div>
              <div class="gplay-logo" v-else-if="receiptData.payload.Store == 'Paypal'">
                <img
                  src="https://images.ctfassets.net/drk57q8lctrm/21FLkQ2lbOCWynXsDZvXO5/485a163f199ef7749b914e54d4dc3335/paypal-logo.webp" />
              </div>
              <div class="gplay-logo" v-else-if="receiptData.payload.Store == 'AppleAppStore'">
                <img src="https://developer.apple.com/news/images/og/app-store-og-twitter.png" />Apple Store
              </div>
              <div class="gplay-logo" v-else-if="receiptData.payload.Store == 'Custom'">
                <h2>In-House</h2>
              </div>
              <div class="gplay-logo" v-else-if="receiptData.payload.Store == 'fake'">
                <h2>In-House</h2>
              </div>
              <div class="my-3">
                <h2>Thank you</h2>
              </div>

              <!-- <div>You've made a purchase on {{}}.</div> -->
              <div class="google-receipt-order-details">
                <span><b>Order Number:</b>{{receiptData._id}}</span>
                <span><b>Date:</b>{{ convertMS(receiptData.date) }}</span>
              </div>
              <div>
                <div class="google-receipt-details">
                  <div class="google-receipt-items-header">
                    <div>Item</div>
                    <div>Price</div>
                  </div>
                  <div>
                    <div v-if="receiptData.payload.Store == 'GooglePlay'">
                      {{ receiptData.payload.payload.gson.productId }}
                    </div>
                    <div v-else-if="receiptData.payload.Store == 'Paypal'">
                      {{ receiptData._id }}
                    </div>
                    <div v-else-if="receiptData.payload.Store == 'AppleAppStore'">
                      {{ receiptData._id }}
                    </div>
                    <div v-else-if="receiptData.payload.Store == 'Custom'">
                      {{ receiptData._id }}
                    </div>
                    <div v-else>
                      {{ receiptData._id }}
                    </div>
                    <div>&#8369;{{ receiptData.amount.toLocaleString() }}</div>
                  </div>
                  <div>
                    <div></div>
                    <div class="d-flex flex-column align-items-end gap-2">
                      <span>Total: &#8369;{{ receiptData.amount.toLocaleString() }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="custom-receipt" v-else>
            <h2 class="">In House Receipt</h2>
            <p><b>Amount:</b>{{ receiptData.amount }}</p>
            <p><b>Date:</b>{{ convertMS(receiptData.date) }}</p>
          </div> -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="showReceipt = false">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DataTable2 from "data-table/src/components/DataTable2";
  import { api } from "../services/api";
  import ToastService from "toast/src/services/toast";
  import ModalService from "modal/src/services/Modal";
  import Spinner from "./Loaders/Spinner.vue";
  export default {
    name: "WcoinModal",
    data() {
      return {
        trigger: {},
        orderid: "",
        coinValue: 20,
        showAdd: false,
        showReward: false,
        showReceipt: false,
        products: [],
        headers: {
          _id: "ID",
          amount: "value",
        },
        receiptData: null,
        actions: [
          {
            classNames: "fa fa-receipt text-success",
            callback: this.viewReceipt,
          },
          {
            classNames: "fa fa-trash text-danger",
            callback: this.remove,
          },
        ],
        isLoading: false,
      };
    },
    props: {
      data: {
        entity: Object,
        show: Boolean,
      },
      api: Object,
    },
    components: {
      DataTable2,
      Spinner,
    },
    methods: {
      async addTransaction() {
        try {
          await this.api.coinTransaction.addTransaction(
            this.data.entity._id,
            this.orderid,
            this.coinValue
          );
          this.trigger.refresh();
          ToastService.Notify({
            title: "Success",
            message: "Transaction successfully added.",
          });
          this.closeAdd();
        } catch (e) {
          ToastService.Notify({
            title: "Error",
            message: e,
          });
        }
      },

      async addReward() {
        try {
          await this.api.coinTransaction.addReward(this.data.entity._id, this.coinValue);
          this.trigger.refresh();
          ToastService.Notify({
            title: "Success",
            message: "Reward successfully added.",
          });
          this.closeAdd();
        } catch (e) {
          ToastService.Notify({
            title: "Error",
            message: e,
          });
        }
      },

      searchTransaction() {
        let actId = "5755297586881571977";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=800,left=100,top=100`;
        window.open(
          `https://play.google.com/console/u/0/developers/${actId}/orders?search=${this.orderid}`,
          "Transaction",
          params
        );
      },
      closeReceipt() { },
      async addAppleTransaction() {
        let isValid = false;
        let transactions = [];
        try {
          transactions = await this.api.coinTransaction.addTransactionApple(
            this.data.entity._id,
            this.orderid
          );
          isValid = true;
        } catch (e) {
          console.log(e);
        }

        if (isValid) {
          ModalService.Show(
            {
              title: `Transaction added`,
              message: `Response:${JSON.stringify(transactions, null, 2)}`,
            },
            async () => { }
          );
        } else {
          ModalService.Show(
            {
              title: `Transaction verify`,
              message: `Transaction ID is ${isValid ? "VALID" : "INVALID"}!`,
            },
            async () => { }
          );
        }
      },
      closeAdd() {
        this.showAdd = false;
        this.showReward = false;
      },
      close() {
        let data = this.data;
        data.show = false;
      },
      async getTransactions(filter, skip, limit) {
        this.isLoading = true;
        if (filter) {
          filter.profile_id = this.data.entity._id;
          filter.paymentType = 0;
        }
        let transactions = await this.api.coinTransaction.getTransactions(
          filter,
          skip,
          limit
        );
        transactions.data.reverse();
        this.isLoading = false;
        return transactions;
      },

      remove(entity) {
        ModalService.Show(
          {
            title: `Delete Transaction`,
            message: `Do you want to remove ${entity._id}?`,
          },
          async () => {
            await this.api.coinTransaction.remove(entity._id);
            this.trigger.refresh();
            ToastService.Notify({
              title: "Success",
              message: "Transaction successfully deleted.",
            });
          }
        );
      },
      async viewReceipt(entity) {
        this.receiptData = await entity;
        this.showReceipt = true;
      },
      convertMS(ms) {
        let date;

        if (ms != null)
          date = new Date(ms);
        else
          return "N/A"
        return date;
      },
    },
    async created() {
      this.products = await api.getProducts();
      this.products.sort((x, y) => x.coinValue - y.coinValue);
    },
  };
</script>

<style scoped></style>
